var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M470 5104 c-221 -47 -408 -236 -455 -459 -22 -105 -22 -4065 0 -4170 47 -225 235 -413 460 -460 105 -22 4065 -22 4170 0 225 47 413 235 460 460 22 105 22 4065 0 4170 -47 225 -235 413 -460 460 -102 21 -4075 21 -4175 -1z m4153 -414 c21 -14 50 -43 65 -64 l27 -39 0 -2027 0 -2026 -25 -37 c-14 -21 -43 -50 -64 -65 l-39 -27 -604 -3 -603 -3 0 816 0 815 310 0 c171 0 310 3 310 6 0 9 89 556 96 587 l6 27 -362 0 -361 0 3 253 c3 238 4 255 26 302 30 65 83 118 146 147 48 22 65 23 294 26 l242 3 0 310 0 309 -247 0 c-204 0 -264 -4 -339 -19 -351 -73 -620 -327 -716 -678 -19 -69 -22 -111 -26 -365 l-4 -288 -299 0 -299 0 0 -310 0 -310 300 0 300 0 0 -815 0 -815 -1113 2 -1114 3 -39 27 c-21 15 -50 44 -64 65 l-25 37 -3 2004 c-1 1338 1 2017 8 2042 12 46 80 116 124 129 18 6 854 9 2042 8 l2010 -2 37 -25z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.c24edaf568acc330a67d65c10683c034.svg";
export { ForwardRef as ReactComponent };